import React, { useCallback, useEffect, useRef } from 'react';
import { Box } from '@chakra-ui/react';

import AgencyHeroReviewModule from './AgencyHeroReviewModule';

const EMBED_HEIGHT_MESSAGE = 'agency-review-embed-height';

const AgencyReviewEmbed = () => {
  const contentRef = useRef(null);

  const postEmbedHeight = useCallback(() => {
    if (typeof window === 'undefined' || window.parent === window) return;

    const node = contentRef.current;
    if (!node) return;

    const height = Math.ceil(node.getBoundingClientRect().height);
    if (height <= 0) return;

    window.parent.postMessage({ type: EMBED_HEIGHT_MESSAGE, height }, '*');
  }, []);

  useEffect(() => {
    postEmbedHeight();

    const node = contentRef.current;
    const resizeObserver =
      typeof ResizeObserver !== 'undefined' && node
        ? new ResizeObserver(() => postEmbedHeight())
        : null;

    resizeObserver?.observe(node);

    const handleLoad = () => postEmbedHeight();
    window.addEventListener('load', handleLoad);
    window.addEventListener('resize', handleLoad);

    const intervalId = window.setInterval(postEmbedHeight, 500);
    window.setTimeout(() => window.clearInterval(intervalId), 5000);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener('load', handleLoad);
      window.removeEventListener('resize', handleLoad);
      window.clearInterval(intervalId);
    };
  }, [postEmbedHeight]);

  return (
    <Box
      ref={contentRef}
      bg="white"
      w="100%"
      data-testid="agency-review-embed-content"
    >
      <AgencyHeroReviewModule variant="where-they-are" presentation="embed" />
    </Box>
  );
};

export default AgencyReviewEmbed;
